<!-- <div class="bloque-de-bienvenida-section" style="padding-top: 10% !important;"> -->
<div *ngIf="!mostrarReprocan" @fadeInOut class="bloque-de-bienvenida-section">
    <div id="demoFont">Bienvenidos</div>

    <div id="demoFont">¿Ya tienes un usuario?</div>

    <div class="row mt-4">
        <div class="col-6 text-end">
            <a href="#" class="myButton w-50">SI</a>
        </div>
        <div class="col-6 text-start">
            <a href="#" class="myButton w-50" (click)="mostrarSegundaSeccion()">NO</a>
        </div>
    </div>
</div>

<div *ngIf="mostrarReprocan && !mostrarIdentificacionRepro" @fadeInOut class="bloque-de-bienvenida-section">
    
    <div id="demoFont">¿Estás registrado en <a>REPROCAN</a>?</div>

    <div class="sub-text">
        <span>
            Necesitas estar inscripto en <a>REPROCAN</a>
        </span>    
    </div>


    <div class="row mt-4">
        <div class="col-6 text-end">
            <a href="#" class="myButton w-50" (click)="mostrarIdentificacionRepro=true">SI</a>
        </div>
        <div class="col-6 text-start">
            <a href="#" class="myButton w-50" (click)="irADerivaciones()">NO</a>
        </div>
    </div>
</div>

<div *ngIf="mostrarIdentificacionRepro" @fadeInOut class="bloque-de-bienvenida-section">
    <div id="demoFont">Código vínculación <a>REPROCAN</a></div>

    <input type="text" placeholder="Tu codigo de verificación">
    <i class="fa fa-user fa-lg fa-fw" aria-hidden="true"></i>

    <div class="mt-1">
        <a href="#" style="width: 150px;" class="myButton w-50" (click)="openModalConfirmarCodigoRepro()">Validar y continuar</a>    
    </div>
</div>

<div class="modal fade" id="myModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>Estaremos validando la información</span>
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closeModalConfirmarCodigoRepro()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p> <span>Puede continuar y luego le daremos aviso vía email</span></p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark" (click)="irARegistro()">Continuar registro</button>
            </div>
        </div>
    </div>
</div>


<!-- <div class="modal" id="myModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span>Estaremos validando la información</span>
                </h4>
                <button type="button" class="close" aria-label="Close" (click)="closeModalConfirmarCodigoRepro()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p> <span>Puede continuar y luego le daremos aviso vía email</span></p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-dark" (click)="irARegistro()">Continuar registro</button>
            </div>
        </div>
    </div>
</div> -->
